import { FOOD_BENEFIT_STATES } from 'common/domain/constants';

class UserCardRowController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    this.cardsBackup = angular.copy(this.cards);
    this.checkHasManager();
    this.setCardHasManager();
  }

  setModifiedCards($event) {
    let event = this.EventEmitter($event);
    this.notifyModify(event);
  }

  createPeriod($event) {
    let event = this.EventEmitter($event);
    this.notifySend(event);
  }

  daysIsFocused($event) {
    let event = this.EventEmitter($event);
    this.cardDaysFocused(event);
  }

  resetCardState(card) {
    let originalCard = this.cardsBackup.find((cardBackup) => {
      return cardBackup.id === card.id && cardBackup.enjoymentMonth === card.enjoymentMonth;
    });

    if (card.state === FOOD_BENEFIT_STATES.error && originalCard.state === FOOD_BENEFIT_STATES.error) {
      card.state = this.originalCardState;
    } else if (!this.originalCardState && this.originalCardState !== '') {
      card.state = FOOD_BENEFIT_STATES.requested;
    } else {
      card.state = this.originalCardState || FOOD_BENEFIT_STATES.initial;
    }

    card.requestErrorMsg = undefined;
    card.enjoymentDays = originalCard.enjoymentDays;
    this.onCloseCard();
  }

  checkHasManager(){
    this.withoutManager = true;
    if(this.profile.managerId !== null){
      this.withoutManager = false;
    }
  }

  setCardHasManager(){
    this.cards.forEach((card) => {
      card.hasManager = !this.withoutManager;
    });
  }
}

export default UserCardRowController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/userCardRow.controller.js